<template>
	<div ref="grid" class="grid" :style="{gridTemplateColumns}">
		<slot />
		<!-- gutters are added/removed programmatically and work together with the grid-template-columns -->
		<div
			v-for="gutter in columnGutters"
			:key="gutter.track"
			:ref="`column-gutter-${gutter.track}`"
			:style="{
				gridColumn: gutter.gridColumn,
				padding: `0 ${gutterPadding}`,
				margin: `0 -${gutterPadding}`,
				gridRow: '1/-1',
				cursor: 'col-resize',
			}"
		>
			<div
				class="h-full bg-gray-550"
				:class="`bg-${gutterColor}`"
				:style="{
					width: gutterWidth,
				}"
			/>
		</div>
	</div>
</template>

<script>
import Split from 'split-grid'
// docs: https://github.com/nathancahill/split/tree/master/packages/split-grid
import delay from 'shared/utils/delay'

export default {
	name: 'SplitPanels',
	props: {
		defaultColumns: {type: Array, default: () => ['1fr']},
		gutterWidth: {type: String, default: '1px'},
		gutterPadding: {type: String, default: '8px'},
		gutterColor: {type: String, default: 'gray-550'},
		options: {type: Object, default: () => ({})},
		localStorageKey: {type: String, default: null},
	},
	data() {
		return {
			columns: [],
			split: null,
			defaultOptions: {
				minSize: 50,
				onDragEnd: this.persistColumns,
			},
			columnGutters: [],
		}
	},
	computed: {
		gridTemplateColumns() {
			return this.columns.join(` ${this.gutterWidth} `)
		},
	},
	watch: {
		'defaultColumns.length': 'updateColumnGutters',
	},
	unmounted() {
		this.split.destroy()
	},
	mounted() {
		const storedColumns = JSON.parse(localStorage?.[this.localStorageKey] || '[]')
		this.columns = storedColumns.length === this.defaultColumns.length ? storedColumns : this.defaultColumns
		this.split = Split({...this.defaultOptions, ...this.options})
		this.updateColumnGutters()
	},
	methods: {
		persistColumns() {
			if (!this.localStorageKey) return
			const gridTemplateColumns = this.$refs.grid.style.gridTemplateColumns
			this.columns = gridTemplateColumns.split(` ${this.gutterWidth} `)
			if (localStorage) localStorage[this.localStorageKey] = JSON.stringify(this.columns)
		},
		async updateColumnGutters() {
			if (this.columns.length !== this.defaultColumns.length) this.columns = this.defaultColumns
			this.clearColumnGutters()
			const columnCount = this.columns.length
			for (let i = 0; i < columnCount - 1; i++) {
				await this.addColumnGutter(i * 2 + 1)
			}
		},
		async addColumnGutter(track) {
			this.columnGutters.push({track, gridColumn: `${track + 1}`})
			await this.$nextTick()
			while (!this.$refs[`column-gutter-${track}`]) await delay(50)
			this.split.addColumnGutter(this.$refs[`column-gutter-${track}`][0], track)
		},
		clearColumnGutters() {
			this.columnGutters.forEach(({track}) => this.split?.removeColumnGutter(track, true))
			this.columnGutters = []
		},
	},
}
</script>
